import { APIS } from "../../../config/apis"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { ServerRequest } from "../../../utils/apiweb"
export const getTipoMultas = ({ onSuccess, onDone }) => {
    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.TIPO_MULTA,
        null,
        null,
        res => {
            res.json().then(data => {
                onSuccess(data)
            }).catch((error) => {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error)
            }).finally(onDone)
        },
        response => {
            response.json().then((error) => {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
            }).catch((error) => {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error);
            }).finally(onDone)
        },
        error => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando solicitud: ' + error.message)
            onDone()
        },
    )
}

export const generateInitMulta = (idCuenta) => ({
    id: -new Date(),
    idCuenta: idCuenta,
    idTipoMulta: 0,
    idUnidadValor: 0,
    valor: 0,
    periodo: '',
    mes: 0,
    fecha: new Date(),
    idTasa: 0,
    idSubTasa: 0,
    state: 'a',
})
